module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/compiling-1d77b4657cec99ee795c91e0a29561ee.svg";